import { render, staticRenderFns } from "./TableTasks.vue?vue&type=template&id=6856a983&"
import script from "./TableTasks.vue?vue&type=script&lang=js&"
export * from "./TableTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports